// import React, { useEffect, useState } from "react";
// import { PostStoreTab, StoreTab } from "../../../Services/StoreHub";
// import { Autocomplete, TextField } from "@mui/material";
// import { LeftMenu } from "../../../MockItems";
// import { toast } from "react-toastify";

// const TabModal = ({ store, open, onClose }) => {
//   const [tabData, setTabData] = useState([]);
//   const [selectedTabs, setSelectedTabs] = useState([]);

//   const fetchStoreTabapi = async (id) => {
//     try {
//       const res = await StoreTab({ store_id: id });

//       setSelectedTabs(res?.data.data?.tab || []);
//     } catch (err) {
//       throw new Error(err);
//     }
//   };

//   const PostStoreTabapi = async (id, tabArray) => {
//     try {
//       const res = await PostStoreTab({ store_id: id, tab: tabArray });
//       if (res?.data?.response_code === 200) {

//         toast.success(res?.data?.message)
//         onClose()
//       }

//       else {
//         toast.warn(res?.data?.message)
//       }
//     } catch (err) {
//       throw new Error(err);
//     }
//   };

//   useEffect(() => {
//     if (store?.id && open) {
//       fetchStoreTabapi(store?.id);
//     } else {
//       setTabData([]);
//     }
//   }, [store?.id, open]);
//   if (!open || !store) return null;

//   const childMenuItems = LeftMenu
//     .filter((item) => item.children)
//     .flatMap((item) => item.children)
//     .filter((child) => child.navItem)
//     .map((child) => child.navItem);

//   return (
//     <div>
//       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//         <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 relative">
//           <button
//             onClick={onClose}
//             className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-xl"
//           >
//             &times;
//           </button>

//           <p className="text-xl font-semibold text-gray-800 mb-4">
//             Select Tabs for {store.store_name}
//           </p>

//           {/* <div className="mb-6">
//             <label
//               htmlFor="tabSelect"
//               className="block text-sm font-medium text-gray-700 mb-2"
//             >
//               Choose a Tab
//             </label>
//             <select
//               id="tabSelect"
//               className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//             >
//               {tabData.length > 0 ? (
//                 tabData.map((tab, index) => (
//                   <option key={index} value={tab}>
//                     {tab}
//                   </option>
//                 ))
//               ) : (
//                 <option disabled>No tabs available</option>
//               )}
//             </select>
//           </div> */}

//           <div className="mb-6">
//             <label
//               htmlFor="tabSelect"
//               className="block text-sm font-medium text-gray-700 mb-2"
//             >
//               Choose a Tab
//             </label>

//             <Autocomplete
//               multiple
//               disableCloseOnSelect

//               limitTags={4}
//               id="tabSelect"
//               options={childMenuItems}
//               getOptionLabel={(option) => option}
//               value={selectedTabs}

//               onChange={(event, value) => {

//                 const tabNames = value.map((item) => item);
//                 setSelectedTabs(tabNames);

//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   placeholder="Search...."
//                   variant="outlined"
//                   size="small"
//                   fullWidth
//                 />
//               )}
//               className="w-full"
//             />
//           </div>

//           <div className="mt-6  flex items-center  justify-between">
//             <button
//               onClick={onClose}
//               className="px-4 py-2 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition"
//             >
//               Close
//             </button>

//             <button
//               onClick={() => PostStoreTabapi(store?.id, selectedTabs)}
//               className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition"
//             >
//               Submit
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TabModal;

import React, { useEffect, useState } from "react";
import { PostStoreTab, StoreTab } from "../../../Services/StoreHub";
import { Autocomplete, TextField } from "@mui/material";
import { LeftMenu } from "../../../MockItems";
import { toast } from "react-toastify";

const TabModal = ({ store, open, onClose }) => {
  const [tabData, setTabData] = useState([]);
  const [selectedTabs, setSelectedTabs] = useState([]);

  const fetchStoreTabapi = async (id) => {
    try {
      const res = await StoreTab({ store_id: id });
      setSelectedTabs(res?.data?.data?.tab || []);
    } catch (err) {
      console.error(err);
    }
  };

  const PostStoreTabapi = async (id, tabArray) => {
    try {
      const res = await PostStoreTab({ store_id: id, tab: tabArray });

      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        onClose();
      } else {
        toast.warn(res?.data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (store?.id && open) {
      fetchStoreTabapi(store.id);
    } else {
      setTabData([]);
    }
  }, [store?.id, open]);

  if (!open || !store) return null;

  const childMenuItems = LeftMenu.filter((item) => item.children)
    .flatMap((item) => item.children)
    .filter((child) => child.navItem)
    .map((child) => child.navItem);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2 sm:px-4">
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md sm:max-w-lg
                   max-h-[90vh] overflow-y-auto p-4 sm:p-6 relative"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-2xl"
        >
          &times;
        </button>

        {/* Title */}
        <p className="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
          Select Tabs for {store.store_name}
        </p>

        {/* Autocomplete */}
        <div className="mb-6">
          <label
            htmlFor="tabSelect"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Choose Tabs
          </label>

          <Autocomplete
            multiple
            disableCloseOnSelect
            limitTags={2}
            fullWidth
            id="tabSelect"
            options={childMenuItems}
            getOptionLabel={(option) => option}
            value={selectedTabs}
            onChange={(event, value) => setSelectedTabs(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search..."
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
        </div>

        {/* Actions */}
        <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-between">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition"
          >
            Close
          </button>

          <button
            onClick={() => PostStoreTabapi(store?.id, selectedTabs)}
            className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default TabModal;
